var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : 'button',{tag:"component",class:[
    _vm.isSecondary ? 'corp-button--isSecondary' : null,
    _vm.hasFullWidth ? 'corp-button--hasFullWidth' : null,
    _vm.spinner ? 'corp-button--hasLoader' : null,
    'corp-button'
  ],attrs:{"type":!_vm.to ? _vm.type : false,"to":_vm.to,"disabled":_vm.isDisabled}},[(_vm.spinner)?_c('span',{staticClass:"corp-button__loader"},[_c('span',{staticClass:"spinner"})]):[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }